import script from "./MenuBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBackground.vue?vue&type=script&setup=true&lang=js"

import "./MenuBackground.vue?vue&type=style&index=0&id=4dc71f1e&lang=scss&scoped=true"
import "./MenuBackground.vue?vue&type=style&index=1&id=4dc71f1e&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc71f1e"]])

export default __exports__